import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { resolveGrandeTesteContent, type GrupoOverride, type PerguntaOverride } from '@/lib/grandeTesteContent';

const localContent = resolveGrandeTesteContent();

export function useGrandeTesteSummary() {
  const { data } = useQuery({
    queryKey: ['grande-teste-summary'],
    staleTime: 60_000,
    queryFn: async () => {
      const [grupos, perguntas] = await Promise.all([
        supabase.from('grande_teste_grupos').select('*').order('display_order'),
        supabase.from('grande_teste_perguntas').select('*').order('display_order'),
      ]);
      if (grupos.error) throw grupos.error;
      if (perguntas.error) throw perguntas.error;
      return resolveGrandeTesteContent(grupos.data as GrupoOverride[], perguntas.data as PerguntaOverride[]);
    },
  });
  const content = data ?? localContent;
  return { totalPerguntas: content.perguntas.length, totalCapitulos: content.grupos.length };
}